export const PARANOIDI_UPDATES = [
  {
    id: "english-language-support",
    date: "2026-09-02",
    fi: "Paranoidi toimii nyt myös englanniksi.",
    en: "Paranoidi is now available in English.",
  },
  {
    id: "print-products",
    date: "2026-09-02",
    fi: "Painotuotteiden suunnittelu ja tilaaminen on nyt käytössä.",
    en: "Print product design and ordering is now available.",
  },
  {
    id: "events-date-time-picker",
    date: "2026-08-31",
    fi: "Tapahtumien päivämäärien ja kellonaikojen valintaa uudistettiin.",
    en: "Choosing dates and times for events has been improved.",
  },
  {
    id: "song-library-tempo",
    date: "2026-08-31",
    fi: "Biisikirjastoon lisättiin tempo sekä nopeammat työkalut useiden biisien hallintaan.",
    en: "Tempo and faster tools for managing multiple songs were added to the song library.",
  },
  {
    id: "song-import-lyrics-chords",
    date: "2026-08-31",
    fi: "Biisien tuontia parannettiin: sanat ja soinnut säilyvät nyt mukana SongBook- ja ChordPro-tiedostoista.",
    en: "Song importing was improved: lyrics and chords are now preserved from SongBook and ChordPro files.",
  },
  {
    id: "setlist-improvements",
    date: "2026-08-31",
    fi: "Settilistojen rakentamista, tallentamista ja käyttöä keikalla parannettiin.",
    en: "Building, saving and using setlists during gigs has been improved.",
  },
  {
    id: "light-dark-theme",
    date: "2026-08-17",
    fi: "Hallintaan lisättiin vaalea ja tumma teema.",
    en: "Light and dark themes were added to the performer dashboard.",
  },
  {
    id: "reader-prompter-update",
    date: "2026-08-17",
    fi: "Lukutilaa ja prompteria uudistettiin sanojen, sointujen ja muistiinpanojen käyttöä varten.",
    en: "Reader mode and the prompter were improved for lyrics, chords and notes.",
  },
  {
    id: "gig-tools-update",
    date: "2026-08-17",
    fi: "Keikkamuisti, yhteenveto ja keikkaraportit uudistettiin osaksi sujuvampaa keikkatyöskentelyä.",
    en: "Gig notes, summaries and gig reports were improved for smoother use during gigs.",
  },
  {
    id: "mobile-install",
    date: "2026-08-17",
    fi: "Paranoidin voi nyt asentaa Android-puhelimeen sovelluksen tapaan.",
    en: "Paranoidi can now be installed on an Android phone like an app.",
  },
  {
    id: "public-launch",
    date: "2026-07-10",
    fi: "Paranoidi avautui esiintyjille.",
    en: "Paranoidi officially opened to performers.",
  },
  {
    id: "subscriptions",
    date: "2026-07-08",
    fi: "Basic- ja Plus-tilaukset sekä oman tilauksen hallinta otettiin käyttöön.",
    en: "Basic and Plus subscriptions and subscription management became available.",
  },
  {
    id: "trial",
    date: "2026-06-30",
    fi: "Paranoidiin lisättiin 14 päivän maksuton kokeilu.",
    en: "A 14-day free trial was added to Paranoidi.",
  },
  {
    id: "paranoidi-fi",
    date: "2026-06-29",
    fi: "Paranoidi sai oman osoitteensa: paranoidi.fi.",
    en: "Paranoidi got its own home at paranoidi.fi.",
  },
  {
    id: "first-pilots",
    date: "2026-06-23",
    fi: "Ensimmäiset esiintyjät aloittivat Paranoidin käytön pilottivaiheessa.",
    en: "The first performers started using Paranoidi during its pilot phase.",
  },
];